module.exports = __webpack_public_path__ + "media/images/recruitment/landing/img_simulation_sp-4940b857648e24e0e2b41939f3ac8cb4.png";